export default class FieldsMappingService {
    constructor(http) {
        this.http = http;
    }

    getData() {
        const self = this;
        return new Promise(function(resolve, reject) {
            self.http.get(self.backendUrl + '/mappings/fields').then(
                (response) => {
                    if (response.status === 200 && response.data) {
                        resolve(self.fillAvailableValuesAndGroupMappings(response.data));
                    }
                },
                (err) => {
                    reject(err);
                }
            );
        });
    }

    fillAvailableValuesAndGroupMappings(responseData) {
        let self = this;
        let groupedMappings;
        if (responseData.Mappings) {
            let mappings = responseData.Mappings;

            let wrappedMappings = [];
            mappings.forEach(mapping => {
                let wrappedMapping = self.wrapMappingForView(mapping, responseData.JiraFieldsNames, responseData.TfsFieldsNames);
                wrappedMappings.push(wrappedMapping);
            })

            groupedMappings = this.group(wrappedMappings);

            let jiraFields = self.updateJiraFieldNamesVisibility(wrappedMappings, responseData.JiraFieldsNames);

            let tfsFields = self.updateTfsFieldNamesVisibility(wrappedMappings, responseData.TfsFieldsNames);

            return {
                jiraFields,
                tfsFields,
                groupedMappings
            };
        }
    }

    updateJiraFieldNamesVisibility(mappings, jiraFieldNames) {
        jiraFieldNames.forEach(field => {
            field.Hidden = mappings.some(
                mapping => mapping.JiraField.Key == field.Key
            );
        });
        return jiraFieldNames;
    }

    updateTfsFieldNamesVisibility(mappings, tfsFieldNames) {
        tfsFieldNames.forEach(field => {
            field.Hidden = mappings.some(
                mapping => mapping.TfsField.Key == field.Key
            );
        });

        return tfsFieldNames;
    }

    updateMappingDirection(mapping) {
        if (mapping.Direction === 1 || mapping.Direction === '-tfs-to-jira') {
            mapping.Direction = '-tfs-to-jira';
        } else if (mapping.Direction === 2 || mapping.Direction === '-jira-to-tfs') {
            mapping.Direction = '-jira-to-tfs';
        } else {
            mapping.Direction = '-both';
        }
        return mapping;
    }

    group(mappings) {
        let self = this;
        let mappingRows = [];
        mappings.forEach(mapping => {
            mappingRows.push(mapping);
        });

        let tfsGroups = [];
        mappingRows.forEach(mapping => {
            let alreadyInGroup = tfsGroups.find(group => {return group.groupBy === mapping.TfsField.Key});
            if (!alreadyInGroup) {
                let sameTfsMappings = mappings.filter(function(x) {return x.TfsField.Key === mapping.TfsField.Key});
                 if (sameTfsMappings.length > 1) {
                    let group = self.createNewGroup(sameTfsMappings, mapping.TfsField.Key, 'tfs');
                    tfsGroups.push(group);
                }
             }
        });

        let jiraGroups = [];
        mappingRows.forEach(mapping => {
            let alreadyInGroup = jiraGroups.find(group => {return group.groupBy === mapping.JiraField.Key});
            if (!alreadyInGroup){
            let sameJiraMappings = mappings.filter(function(x) {return x.JiraField.Key === mapping.JiraField.Key});
             if (sameJiraMappings.length > 1) {
                    let group = self.createNewGroup(sameJiraMappings, mapping.JiraField.Key, 'jira');
                    jiraGroups.push(group);
                }
             }
        });

        let mergedGroups = tfsGroups.concat(jiraGroups);
        mappingRows.forEach(mapping => {
            let isInGroup = mergedGroups.find(group => {return group.groupBy === mapping.JiraField.Key || group.groupBy === mapping.TfsField.Key});
            if (!isInGroup) {
                let group = self.createNewGroup([mapping], mapping.JiraField.Key, 'none');
                mergedGroups.push(group);
            }
        });

        mergedGroups.forEach(group => self.updateMappingsInGroup(group));

        return mergedGroups;
    }

    addMapping(jiraField, tfsField, jiraFields, tfsFields, mappingsGroups) {
        const self = this;
        let url = self.backendUrl + '/mappings/fields?jiraField=' + encodeURIComponent(jiraField.Key) + '&tfsField=' + encodeURIComponent(tfsField.Key);
        return new Promise(function(resolve, reject) {
            self.http.post(url).then(
                (response) => {
                    if (response.data) {
                        let newMapping = self.createNewMapping(response.data, jiraFields, tfsFields);
                        let isPossibleToAddToGroup = false;
                        let existingGroup = {};
                        mappingsGroups.forEach(group => {
                            if (group.mappings.some(mapping => mapping.JiraField.Key === newMapping.JiraField.Key)) {
                                isPossibleToAddToGroup = true;
                                existingGroup = group;
                                existingGroup.groupBy = newMapping.JiraField.Key;
                                existingGroup.kind = 'jira';
                            } else if (group.mappings.some(mapping => mapping.TfsField.Key === newMapping.TfsField.Key)) {
                                isPossibleToAddToGroup = true;
                                existingGroup = group;
                                existingGroup.groupBy = newMapping.TfsField.Key;
                                existingGroup.kind = 'tfs';
                            }
                        });

                        if (isPossibleToAddToGroup) {
                            self.addMappingToGroup(newMapping, existingGroup.groupBy, mappingsGroups, existingGroup.kind);
                        } else {
                            let newGroup = self.createNewGroup([newMapping], newMapping.JiraField.Key, 'none');
                            self.updateMappingsInGroup(newGroup);
                            mappingsGroups.push(newGroup);
                        }
                        self.sendNotificationIfEpicNameChanged(newMapping);
                        resolve({
                            jiraFields: jiraFields.filter(field => field.Key !== jiraField.Key),
                            tfsFields: tfsFields.filter(field => field.Key !== tfsField.Key),
                            groupedMappings: mappingsGroups
                        });
                    }
                },
                (err) => {
                    reject(err);
                }
            )
        });
    }

    removeMapping(jiraFields, tfsFields, mapping, mappingsGroups) {
        const self = this;
        return new Promise(function(resolve, reject) {
            self.http.delete(self.backendUrl + '/mappings/fields/' + mapping.Id).then(
                (response) => {
                    if (response.data && response.status === 200) {
                        self.removeMappingFromGroup(mapping, mappingsGroups);
                        self.updateAvailableFields(mappingsGroups, tfsFields, jiraFields);
                        self.sendNotificationIfEpicNameChanged(mapping);
                        resolve({
                            jiraFields: jiraFields,
                            tfsFields: tfsFields,
                            groupedMappings: mappingsGroups
                        });
                    }
                },
                (err) => {
                    reject(err);
                }
            )
        });
    }

    setMappingAsDefault(mapping, mappingsGroups) {
        const self = this;
        return new Promise(function(resolve, reject) {
            self.http.put(self.backendUrl + '/mappings/fields/' + mapping.Id + '/default').then(
                (response) => {
                    if (response.status === 200) {
                        let currentGroup = mappingsGroups.find(el => el.groupBy === mapping.groupId);
                        currentGroup.mappings.forEach(el => {
                                    self.updateMappingDirection(el);
                                    el.Default = el.Id === mapping.Id ? true : false;
                                });
                        resolve({groupedMappings: mappingsGroups});
                    }
                },
                (err) => {
                    reject(err);
                }
            )
        });
    }

    addMappingToGroup(mapping, groupId, mappingsGroups, kindOfGroup) {
        let self = this;
        let currentGroup = mappingsGroups.find(el => el.groupBy === groupId);
        if (currentGroup) {
            currentGroup.kind = kindOfGroup;
            let groupId = kindOfGroup === 'tfs' ? mapping.TfsField.Key : mapping.JiraField.Key;
            currentGroup.groupBy = groupId;
            if(currentGroup.mappings.length == 1 && !currentGroup.mappings[0].Default && !mapping.Default) {
                self.setMappingAsDefault(currentGroup.mappings[0], mappingsGroups);
            }
            currentGroup.mappings.push(mapping);
            currentGroup.mappings.forEach(el => el.groupId = groupId);
            self.updateMappingsInGroup(currentGroup);
        }
    }

    removeMappingFromGroup(mapping, mappingsGroups) {
        let self = this;
        let currentGroup = mappingsGroups.find(group => group.groupBy === mapping.groupId);
        if (currentGroup) {
            currentGroup.mappings = Array.prototype.filter.call(currentGroup.mappings, (el) => el.Id !== mapping.Id);
            if (currentGroup.mappings.length === 1) {
                let groupId = currentGroup.mappings[0].JiraField.Key;
                currentGroup.kind = 'none';
                currentGroup.groupBy = groupId;
                currentGroup.mappings[0].groupId = groupId;
            }
            if (currentGroup.mappings.length > 0) {
                self.updateMappingsInGroup(currentGroup);
            } else {
                mappingsGroups = Array.prototype.filter.call(mappingsGroups, (group) => group.groupBy !== currentGroup.groupBy);
            }
        }
    }

    updateAvailableFields(groups, tfsFields, jiraFields) {
        let self = this;

        let mappings = [];

        groups.forEach(group => {
            Array.prototype.push.apply(mappings, group.mappings);
        });

        jiraFields = self.updateJiraFieldNamesVisibility(mappings, jiraFields);
        tfsFields = self.updateTfsFieldNamesVisibility(mappings, tfsFields);
    }

    sendNotificationIfEpicNameChanged(mapping) {
        if (mapping.JiraField.Value === "Epic Name") {
            window.Spartez.Shared.sendNotification('FieldMappingChanged', {});
        }
    }

    createNewMapping(mappingData, jiraFields, tfsFields) {
        const self = this;
        let mapping = mappingData;
        return self.wrapMappingForView(mapping, jiraFields, tfsFields);
    }

    createNewGroup(mappings, groupId, kindOfGroup) {
        let self = this;
        mappings.forEach(mapping => mapping.groupId = groupId);
        let group = {
            "groupBy": groupId,
            "mappings": mappings,
            "kind": kindOfGroup
        };
        self.enrichGroupForView(group);
        return group;
    }

    enrichGroupForView(group) {
        let primaryMapping = group.mappings.find(mapping => mapping.Default);
        group.Direction = primaryMapping ? primaryMapping.Direction : '-both';
    }

    updateMappingsInGroup(group) {
        let self = this;
        if (group.kind === 'tfs') {
            group.mappings.forEach(mapping => mapping.isLastInTfsGroup = group.mappings.indexOf(mapping) === group.mappings.length - 1);
        } else if (group.kind === 'jira') {
            group.mappings.forEach(mapping => mapping.isLastInJiraGroup = group.mappings.indexOf(mapping) === group.mappings.length - 1);
        } else {
            group.mappings[0].isLastInJiraGroup = true;
            group.mappings[0].isLastInTfsGroup = true;
        }
        self.enrichGroupForView(group);
    }

    wrapMappingForView(mapping, jiraFields, tfsFields) {
        let self = this;

        function createWrappedMapping(mapping, jiraFieldName, tfsFieldName, isAvailableJiraField) {
            return {
                JiraField: createMappingField(mapping.JiraField, jiraFieldName, isAvailableJiraField),
                TfsField: createMappingField(mapping.TfsField, tfsFieldName, true),
                Id: mapping.Id,
                Default: mapping.Default,
                Direction: mapping.Direction,
                NeedsAttention: mapping.NeedsAttention,
                Immutable: !isAvailableJiraField
            };
        };

        function createMappingField(fieldKey, fieldValue, isAvailable) {
            return {
                Key: fieldKey,
                Value: fieldValue,
                Info: {
                    Type:'',
                    Message: ''
                },
                HasInfo: false,
                IsAvailable: isAvailable
            }
        };

        let isAvailableJiraField = jiraFields.some(field => field.Key == mapping.JiraField);
        let jiraFieldName = isAvailableJiraField ? jiraFields.find(field => field.Key == mapping.JiraField).Value : mapping.JiraField;
        let tfsFieldName = tfsFields.some(field => field.Key == mapping.TfsField)? tfsFields.find(field => field.Key == mapping.TfsField).Value : mapping.TfsField;
        let wrappedMapping = createWrappedMapping(mapping, jiraFieldName, tfsFieldName, isAvailableJiraField);

        self.getHelpForMapping(wrappedMapping);
        self.updateMappingDirection(wrappedMapping);
        return wrappedMapping;
    }

    getHelpForMapping(mapping) {
        if (mapping.JiraField.Key === 'timetracking') {
            mapping.JiraField.Info.Type = 'info';
            mapping.JiraField.Info.Message =  '<ul>' +
                '<li>For Time Tracking fields in TFS type of <b>double</b> should be used. We assume that time in this fields will be stored in <b>hours</b>.</li>' +
                '<li><b>Logged time</b> in Jira cannot be decreased so value of Logged Time in TFS that is lower than Jira Logged Time won\'t be synchronized.</li>' +
                '<li>For best results <b>Original Estimate</b> and <b>Remaining Estimate</b> fields should be synchronized in pair or none at all because ' +
                'not synchronized field will be set to the same value as synchronized field anyway (but only in Jira).</li>' +
                '</ul>';
            mapping.JiraField.HasInfo = true;
        }
        if (mapping.JiraField.Key === "project") {
            mapping.JiraField.Info.Type = 'info';
            mapping.JiraField.Info.Message =  'Mapping of the <strong>Project</strong> Jira field is not recommended. ' +
                'If you do use it, always map it to a TFS field containing a Jira project key.<br><br>' +
                "<strong>This field must never be used with bi-directional synchronization, because it interferes with the Synchronizer's ability to find updated Jira issues.</strong>";
            mapping.JiraField.HasInfo = true;
        }
        if (mapping.JiraField.Key === "assignee") {
            mapping.JiraField.Info.Type = 'info';
            mapping.JiraField.Info.Message = 'User fields, such as <strong>assignee</strong> can be automatically mapped in Jira and TFS, ' +
                'provided that both Jira and TFS server are connected to the same Active Directory instance and therefore share their user account data. ' +
                'If this is not the case, please use the "Map Values" option.';
            mapping.JiraField.HasInfo = true;
        }
        if (mapping.JiraField.Key === "###TFS4JIRA###.JIRA.Resolution") {
            mapping.JiraField.Info.Type = 'info';
            mapping.JiraField.Info.Message =  'Mapping Jira <strong>Resolution</strong> field to TFS <strong>Resolved Reason</strong> or <strong>Reason</strong> can be tricky - please <a href="https://apps.appf.re/t4j/doc/sh/resolution-to-resolved-reason-mapping" target="_blank">see the docs</a>';
            mapping.JiraField.HasInfo = true;
        }
        if (mapping.TfsField.Key === "System.Tags") {
            mapping.JiraField.Info.Type = 'info';
            mapping.TfsField.Info.Message = "Tags field can be updated remotely since TFS 2013 Update 2 so in earlier versions of TFS this field won't be updated.";
            mapping.JiraField.HasInfo = true;
        }
        if(!mapping.JiraField.IsAvailable) {
            mapping.JiraField.Info.Type = 'warning';
            mapping.JiraField.Info.Message = 'The custom field is not available on the Jira create screen, this can cause synchronization to work unexpectedly.';
            mapping.JiraField.HasInfo = true;
        }

        mapping.JiraField.HasInfo = mapping.JiraField.Info.Message !== '';
        mapping.TfsField.HasInfo = mapping.TfsField.Info.Message !== '';

        mapping.jiraInfoTooltip = mapping.JiraField.Key + '_tooltip';
        mapping.tfsInfoTooltip = mapping.TfsField.Key + '_tooltip';
    }
}


// WEBPACK FOOTER //
// ./src/service/fieldsMapping.js